export default __webpack_public_path__ + "static/svg--apple-bc79802208cdee8eee22b2cbdb06ae36.svg";